import React from 'react'
import ReactDOM from 'react-dom';
import {Loader} from"@vds/loaders";
import ErrorBoundary from './modules/ErrorHandler';
import { SiteCatalyst } from '../components/modules/SiteCatalyst';
import ContactusOneApp from "./ContactUsPageOneApp";
const hideheader ={
    "display": 'inline'
}
class ContactUsSpinner extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            SpinnerIsActive: false  ,
            EnableContact :false          
        }
        var isCheckContact = localStorage.getItem('IsContactLoaded');   
        if(isCheckContact =='true'){          
            setTimeout(() => {
                let activebln = false;
                this.setState({SpinnerIsActive: activebln})
                let Enabledata = true;
              this.setState({EnableContact: Enabledata})
              localStorage.removeItem("IsContactLoaded");
              localStorage.setItem('IsContactLoaded',false);
             
          }, 10);                      
           
        }else{
            setTimeout(() => {
                let activeblnn = true;
                this.setState({SpinnerIsActive: activeblnn})
          }, 50);
            localStorage.removeItem("IsContactLoaded");            
            localStorage.setItem('IsContactLoaded',false);           
        }
        
        this.rootElement = document.getElementById('root');
        this.dialogWrapper = document.createElement('div');
        this.isactive = false;              
      
    }

    componentDidMount() {
        this.rootElement.appendChild(this.dialogWrapper);
        const overlay = document.createElement('div');
        overlay.classList.add('modal');
        overlay.classList.add('page-overlay');
        this.dialogWrapper.appendChild(overlay);
        overlay.addEventListener('click', (e)=> {
            this.props.CloseCallBack();
        })
        setTimeout(() => {
            let childData = false;
            this.setState({SpinnerIsActive: childData})
            let Enabledata = true;
          this.setState({EnableContact: Enabledata})
      }, 1500);
    }

    render() {
     return(
        <React.Fragment> 
             <LoaderSpinner SpinnerActive={this.state.SpinnerIsActive} />               
             {
               this.state.EnableContact && <ContactusOneApp  globalSessionID={window.globalSessionID } ContactData={window.contactUsData} DynamicData={window.contactUsDynamicData} ECRMData={window.ecrmData} />
             } 
             <ErrorBoundary>
             <SiteCatalyst PageDetails={window.contactUsData.pagedetails} />
             </ErrorBoundary>
        </React.Fragment>
     )
    }
}

export default ContactUsSpinner

export const LoaderSpinner = ({SpinnerActive}) => {
  return (
    <div>
    <Loader 
    active ={SpinnerActive}
    fullscreen={false} 
    />
    
    </div>
    
  )
}


// WEBPACK FOOTER //
// ./src/components/ContactUsSpinner.js